var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"particles"},[_c('div',{attrs:{"id":_vm.particlesId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }